/* unplugin-vue-components disabled */import script from "./QaView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./QaView.vue?vue&type=script&lang=tsx&setup=true"

import "./QaView.vue?vue&type=style&index=0&id=193dcc46&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193dcc46"]])

export default __exports__